import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ViewportScroller } from '@angular/common';

import { Location } from '@angular/common'
import { Subject, Observable, of, forkJoin } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { OmsService } from '../../services/oms.service';
import { DispatchService } from '../../services/dispatch.service';
import { PrintService } from '../../services/print.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { FormControl } from '@angular/forms';
import { UsersService } from 'app/services/users.service';



declare const google: any;

interface scanner {
	value: string;
	viewValue: string;
}

@Component({
	selector: 'app-dispatches-route-builder',
	templateUrl: './dispatches-route-builder.component.html',
	styleUrls: ['./dispatches-route-builder.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('300ms ease-out')),
			transition('inactive => active', animate('300ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		]),
		trigger('flyInOut', [
			state('in', style({ transform: 'translateX(0)' })),
			transition('void => *', [
				style({ transform: 'translateX(100%)' }),
				animate(300)
			]),
			transition('* => void', [
				animate(300, style({ transform: 'translateX(100%)' }))
			])
		])
	]

})
export class DispatchesRouteBuilderComponent implements OnInit {
	@ViewChild('driverChange') driverChangeRef: ElementRef;
	@ViewChild('viewActive') viewActiveRef: ElementRef;
	@ViewChild('addDestination') addDestinationRef: ElementRef;
	@ViewChild('testingContent') testingContentRef: ElementRef;
	@ViewChild('scantoadd') scantoaddRef: ElementRef;
	@ViewChild('changeTruckEle') changeTruckEleRef: ElementRef;
	@ViewChild('stepper') stepper;
	@ViewChild('changesEle') changesEleRef: ElementRef;

	@ViewChild('orderDetails') orderDetailsRef: ElementRef;
	@ViewChild('assignBay') assignBayRef: ElementRef;
	@ViewChild('assignTracking') assignTrackingRef: ElementRef;

	devicesselected: any = [];
	CHAT_ROOM = 'OrderBoard';
	driverForm: UntypedFormGroup;
	selected_route = new UntypedFormControl('');
	pickstatus = new UntypedFormControl('');
	viewactiverun: any = false;
	customDestination: UntypedFormGroup;
	pointtype = new UntypedFormControl('');
	pointlabel = new UntypedFormControl('');
	pointaddress = new UntypedFormControl('');
	simpletoggle = new UntypedFormControl(true);
	scantoadd1 = new UntypedFormControl('');
	scantoadd2 = new UntypedFormControl('');

	fromTruckOms = new UntypedFormControl('');
	toTruckOms = new UntypedFormControl('');
	searchQuery = '';
	isdispatch = true;
	reloaddispatch = false;
	testcontent: any = false;
	editactivedispatch: any = false;
	allavailableorders: any = false;
	dispatching: any = false;
	flip = 'inactive';
	user: any = [];
	color = 'blue';
	config: any = [];
	pickable: any = [];
	filteredItems: any = [];
	carddata: any = [];
	sortcolumns: any = [];
	allsortcolumns: any = [];
	status: any = [];
	completed_orders: any = [];
	focusdata: any = false;
	runlist: any = [];
	active_run: any = [];
	run_list: any = [];
	reviewDispatch: any = false;
	token = '';
	side = 'right';
	expandEnabled = true;
	columnfocus: any = false;
	innerWidth: any;
	totalonrun: any = 0;
	unpickedcount: any = 0;
	mustbepicked: any = true;
	map: any = false;
	updated_map: any = false;
	markers: any = [false];
	pathlines: any = false;
	map_animation: any = google?.maps.Animation.DROP;
	zoom = 11;
	delsheetlink: any = '';
	selectedRun: any = false;
	drivers: any = [];
	selectedColumn: any = [];
	selectedTruck: any = false;
	focusruntime: any = false;
	driverOverTimeLimit = '';
	inlinedriver = false;
	payment_methods: any = [];
	needpayments: any = [];
	prepay: any = [];
	payments: any = [];
	dispatches: any = [];
	activeDispatches: any = []
	invoicesCreated: any = false;
	sending = false
	addingcardparent = false
	currentStep = 0;
	routes: any = [];
	hovered_item: any = false;
	ordershidden: any = true;
	place: any = [];
	loadDataTime: Date = new Date(); //The date of when the data was loaded
	deliveryStopTime = 300; //Number of seconds that the driver stops to deliver
	deliveryReturnTime = ''; //Return time of the driver
	orderdetails: any = false;
	pickChanges = [];

	scanner: scanner[] = [
		{ value: 'LOADING1', viewValue: 'LOADING1' },
		{ value: 'LOADING2', viewValue: 'LOADING2' },
	];

	// scanneroptions: string[] = ['LOADING1', 'LOADING2'];
	// scanner = new FormControl('');
	title = '';

	pickedFilter = [

		{ label: 'Fillable', value: 'is_fillable' },
		{ label: 'Inbound', value: 'inbound' },
		{ label: 'Is Not Fillable', value: 'is_not_fillable' },
		//{ label: 'Inbound', value: 'inbound' },
		{ label: 'Picked', value: 'picked_only' },
		{ label: 'Partially Picked', value: 'partial_pick' },
		{ label: 'Credit', value: 'credit' },
		{ label: 'Not Due', value: 'not_due_only' },
		{ label: 'Not Due & Picked', value: 'not_due_and_picked' },
	]
	bays: any = false;
	bayGroup: any = false;
	baySelection: any;
	scantoload: any = false;
	order_changes: any = [];
	pickuptrucks: any = [];

	constructor(private printService: PrintService, private fb: UntypedFormBuilder, private dispatchService: DispatchService, public omsService: OmsService, public location: Location, public ordersService: OrdersService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, public formBuilder: UntypedFormBuilder, public inventoryService: InventoryService, private modalService: NgbModal, private usersService: UsersService) {

		this.token = this.globalSearchService.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		this.omsService.setupSocketConnection(this.token);

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			if (this.config.scantotruck) {
				this.scantoload = true;
			}
		})
		this.delsheetlink = this.config.apiServer.baseUrl + this.config.apiServer.runSheet
		this.color = this.globalSearchService.getColor();

	}

	ngOnInit(): void {

		const default_status = ['is_fillable', 'picked_only', 'partial_pick', 'credit'];
		this.pickstatus.setValue(default_status);
		this.globalSearchService.payment_methods.subscribe(result => this.payment_methods = result);
		this.innerWidth = window.innerWidth;

		this.driverForm = this.fb.group({
			driver: ['', Validators.required],
			truck: ['', Validators.required],
		});

		this.customDestination = this.fb.group({
			label: ['', Validators.required],
			address: ['', Validators.required],
			lat: ['', ],
			lng: ['', ],
			type: [''],
			column: [''],
		});

		this.bayGroup = this.fb.group({
			bayno: [''],
			priority: ['0']
		});

		this.dispatchService.getPickUpTrucks().subscribe((res: any) => {
			this.pickuptrucks = res;
		})


		this.omsService.subscribeToCards((err, data) => {
			switch (data.type) {
			case 'claim':
				this.updateCardStatus(data);
				//this.pickChanges.push("Claim event occurred.");
				break;
			case 'delivery':
				this.loadData();
				//this.pickChanges.push("Delivery event occurred.");
				break;
			case 'pick':
				// Update card status if not a new order
				if (!data.neworder) {

					this.updateCardStatus(data);
				}
				// Load data if it's a new order
				if (data.neworder) {
					this.loadData();
					// Add change to the pickChanges list
					const datet = new Date();
					this.pickChanges.push(datet.toLocaleTimeString() + ' :' + ' New order Created.' + data.orderno);
				} else {
					this.loadOrderChanges();
				}
				break;
			case 'cardupdate':
				//this.loadData();
				//this.carddata = data.data
				this.pickChanges.push('Card updated.');
				break;
			case 'dispatch':
				//this.loadData();
				this.pickChanges.push('Dispatch event occurred.');
				break;
			}

			this.getUnPicked();
		});
		//load routes once
		this.dispatchService.getRoutes().subscribe((r: any) => {
			this.routes = r
			this.loadData()
		});

	}

	findAndUpdateInAllLists(orderno: string, updateProperties: any) {
		// Define collections to update
		const collectionsToUpdate = [
			this.filteredItems,
			this.allavailableorders,
			this.focusdata?.length ? this.focusdata : null,
			...Object.values(this.carddata)
		].filter(Boolean); // Filter out any null or undefined collections

		// Loop through each collection and update
		collectionsToUpdate.forEach((collection: any[]) => {
			const item = collection.find(item => item.orderno === orderno);
			if (item) {
				Object.assign(item, updateProperties);
			}
		});
	}

	findOrderByOrderNo(orderNo: string, data: any) {
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				const orders = data[key];
				const order = orders.find((o: any) => o.orderno === orderNo);
				if (order) {
					return order;
				}
			}
		}
		return null; // Return null if order is not found
	}

	noNewLines(input: any) {
		if (input) {
			return input.replace(/[^\x20-\x7E]/gmi, ' ').trim().replace(/\\n/g, ' ');
		}
		return input;
	}

	updateCardStatus(data: any) {
		const { orderno, partial, complete, claimstatus } = data;
		const updateProperties = { partial_pick: partial, pick_complete: complete, claimstatus };

		const updateAllItems = (itemCollections: any[]) => {
			itemCollections.forEach((items: any[]) => {
				const item = items.find((item: any) => item.orderno === orderno);
				if (item) {
					Object.assign(item, updateProperties);
				}
			});
		};

		// Collect all arrays to update
		const itemCollections = [this.filteredItems, this.allavailableorders];
		if (this.focusdata && this.focusdata.length) {
			itemCollections.push(this.focusdata);
		}
		itemCollections.push(...Object.values(this.carddata));

		// Update all relevant items in each collection
		updateAllItems(itemCollections);
	}


	findAndUpdateItem(items: any[], orderno: string, updateProperties: any): any {
		const index = items.findIndex((item: any) => item.orderno === orderno);
		if (index === -1) {return null;} // Item not found

		const originalItem = { ...items[index] }; // Copy of the original item

		// Update the item immutably
		items[index] = { ...originalItem, ...updateProperties };

		return originalItem; // Return the original item
	}

	findCardItem(data: any): any[] {

		const { orderno, partial, complete, claimstatus } = data;
		const updateProperties = { partial_pick: partial, pick_complete: complete, claimstatus };

		const originalItems: any[] = [];

		// Define collections to update
		const collectionsToUpdate = [
			this.filteredItems,
			this.allavailableorders,
			this.focusdata?.length ? this.focusdata : null,
			...Object.values(this.carddata)
		].filter(Boolean); // Filter out any null or undefined collections

		// Loop through each collection and update
		collectionsToUpdate.forEach((collection: any[]) => {
			const originalItem = this.findAndUpdateItem(collection, orderno, updateProperties);
			if (originalItem) {
				originalItems.push(originalItem);
			}
		});

		return originalItems;
	}



	getTotalYear(year: any, propertyName: string): number {
		return year[propertyName].reduce((accumulator: number, item: any) => {
			const addon = parseFloat(item.value);
			return accumulator + addon;
		}, 0);
	}

	// Usage example:
	getCostTotalYear(year: any) {
		return this.getTotalYear(year, 'cost');
	}

	getSaleTotalYear(year: any) {
		return this.getTotalYear(year, 'sales');
	}

	getQtyTotalYear(year: any) {
		return this.getTotalYear(year, 'qty');
	}

	viewOrder(orderno: any) {
		this.ordersService.getOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(this.orderDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	exportDisaptchXls(column: any) {
		this.dispatchService.getActiveRun(column).subscribe((results: any) => {
			this.globalSearchService.exportJsonToExcel(results.dispatched, column + 'DeliverySheet' + new Date() + '.xlsx')
		});
	}

	deliverRun(column: any) {
		this.dispatchService.deliverRun(column).subscribe((results: any) => {
			this.reloaddispatch = true;
			//then

		});

	}

	hideOrders() {
		this.ordershidden = (this.ordershidden) ? false : true;
	}

	removeLines() {
		if (this.pathlines) {
			this.pathlines.setMap(null);
		}
	}

	checkPick() {
		const procced = true;
		this.stepper.next();

		// 		if(this.getUnPicked() > 0) {
		// 			procced = confirm('Unpicked Orders, Proceed to Take Payments?');
		// 		}
		//
		// 		if(procced) {
		// 			this.stepper.next();
		// 		}

	}

	getUnPicked(): number {
		let unpicked = 0;
		if (this.focusdata && this.focusdata.length) {
			unpicked = this.focusdata.reduce(function(accumulator, item) {
				let addon = 0;
				if (!item.pick_complete) {
					addon = 1;
				}
				return accumulator + addon;
			}, 0);
		}
		this.unpickedcount = unpicked;
		return unpicked;
	}

	createPayments() {

		const incomplete = this.focusdata.filter(i => !i.pick_complete);
		const proceed = true;
		// if (incomplete.length && proceed) {
		// 	proceed = confirm("There are unpicked orders on this run. Continue?");
		// }

		if (proceed) {
			this.sending = true;
			this.dispatchService.createInvoiceAndPay(this.needpayments).subscribe((results: any) => {
				this.sending = false;
				if (results.success) {
					this.invoicesCreated = results.data;
					this.getPrePay(this.selectedTruck.id);
					this.loadData();
				} else {
					alert(results.message)
					this.getPrePay(this.selectedTruck.id);
					this.loadData();
				}
			})
		}
	}

	getPaid(orderno: any) {
		let paid = false;
		if (this.invoicesCreated) {
			const invoice = this.invoicesCreated.filter(d => { return d.orderno == orderno })[0]
			if (invoice) {
				paid = true;
			}
		}

		return paid;
	}

	getPrePay(run: any) {

		this.invoicesCreated = false;
		this.needpayments = false;
		this.dispatchService.getNeedPrePay(run).subscribe((results: any) => {
			this.needpayments = results;

			results.forEach((pay: any) => {

				if (pay.preselected) {

					const card = pay.cardsonfile.filter(c => {
						return c.profile_id == pay.preselected.profile_id;
					})[0];

					this.setCreditCard(card, pay.details.payments[0])
				} else {
					if (pay.cc_on_file) {
						this.setCreditCard(pay.cardsonfile[0], pay.details.payments[0])
					}
				}
			})

			this.prepay = results;
		});

		this.dispatchService.getPrePaid(run).subscribe((paid: any) => {
			if (paid) {
				if (paid.length) {
					this.invoicesCreated = paid;
				}
			}
		});

		this.getUnPicked();
	}

	prePaid(da: any) {
		//if(this.invoicesCreated)
	}

	removeInvoice(inv: any) {
		const index = this.needpayments.indexOf(inv);
		this.needpayments.splice(index, 1)
	}


	pTotal(payments) {
		return payments.reduce((accumulator, obj) => { return accumulator + parseFloat(obj.payment) }, 0);
	}

	removePayment(payments: any = [], payment) {
		const proceed = confirm('Removing this payment will add the invoice on account, and a seperate payment will need to be taken. Proceed?');
		if (proceed) {
			const index = payments.indexOf(payment);
			payments.splice(index, 1)
		}
	}

	addPayment(da: any, payments: any = []) {
		const addon = {
			payment: da.details.total - this.pTotal(da.details.payments),
			payment_method: '',
			checknumber: '',
		}
		payments.push(addon)
	}

	setCheck(event: any, item: any) {
		item.checknumber = event;
	}

	setPayment(event: any, item: any) {
		item.payment = event;
	}

	setCreditCard(event: any, payment: any) {
		if (event) {
			const method = this.payment_methods.filter(p => {
				return event.card_type.toUpperCase() == p.paymentname.toUpperCase();
			})[0];
			if (method) {
				this.setPaymentMethod(method.paymentid, payment)
			}
			payment.cc_charge = event;
		} else {
			payment.cc_charge = false;
		}
	}

	setPaymentMethod(event: any, payment: any) {
		payment.payment_method = event;
	}

	goToLink(url: string) {
		//, "_blank"
		window.open(url);
	}

	switchPickOnly(event: any) {

		this.loadData();

		if (event.checked) {

		} else {
			//	this.getAllOrders()
		}
	}

	getAllOrders() {
		this.dispatchService.getAllOrders().subscribe((results: any) => {
			this.status = results.status
			this.pickable = results.orders;
			this.allavailableorders = results.orders;
			this.filteredItems = results.orders;
			this.carddata = results.current
			this.sortcolumns = results.columns;
			this.allsortcolumns = results.columns;
		});
	}


	loadOrderChanges() {
		this.dispatchService.getOrderChanges().pipe(
			catchError(error => {
				return of([]); // Fallback to an empty array on error
			})
		).subscribe((orderChanges: any) => {
			// Ensure orderChanges is an array
			const orderChangesArray = Array.isArray(orderChanges) ? orderChanges : [];

			// Set this.order_changes to the validated array
			this.order_changes = orderChangesArray;

			// Process each change
			orderChangesArray.forEach(change => {
				const { orderno } = change;
				const updateProperties = {
					...change,
					updatenote: true
				};

				this.findAndUpdateInAllLists(orderno, updateProperties);
			});
		});
	}




	filteredOrders(): any[] {
		if (!this.searchQuery) {
			return this.order_changes;
		}

		const lowerCaseQuery = this.searchQuery.toLowerCase();
		return this.order_changes.filter(order =>
			order.orderno.toLowerCase().includes(lowerCaseQuery) ||
			order.details.deliverto.toLowerCase().includes(lowerCaseQuery)
		);
	}

	clearSearch() {
		this.searchQuery = '';
	}

	getTotalLineChanges(orderData: any): number {
		return orderData.changes.reduce((total, change) =>
			total + (change.line_changes ? change.line_changes.length : 0), 0
		);
	}

	getTotalHeaderChanges(orderData: any): number {
		return orderData.changes.reduce((total, change) =>
			total + (change.header_changes ? change.header_changes.length : 0), 0
		);
	}

	loadData() {


		this.dispatchService.getOrders().pipe(
			catchError(error => {
				return of({}); // or any fallback data
			})
		).subscribe((results: any) => {
			this.initializeOrderData(results);

			if (!this.focusdata || !this.focusdata.length) {
				this.loadActiveDispatches(results.columns);
			}

			this.updateRouteAndDisplay();
			this.loadOrderChanges();
		});
	}

	initializeOrderData(results: any) {
		const { status, orders, current, columns } = results;
		this.status = status;
		this.pickable = this.allavailableorders = this.filteredItems = orders;
		this.carddata = current;

		if (this.focusdata) {
			this.focusdata = this.carddata[this.columnfocus];
		}

		this.sortcolumns = this.allsortcolumns = columns;
		this.loadDataTime = new Date();
		this.filterOrders();
	}

	loadActiveDispatches(columns: any[]) {
		this.dispatchService.getActiveDispatches().pipe(
			catchError(error => {
				return of({ dispatches: [] }); // fallback
			})
		).subscribe((dres: any) => {
			this.dispatches = dres.dispatches;

			if (columns) {
				columns.forEach((col: any) => {
					const activeDispatch = dres.dispatches.find((d: any) => d.truck === col.id);
					this.activeDispatches[col.id] = activeDispatch || null;
				});
			}
		});
	}

	updateRouteAndDisplay() {
		this.setSeperateRouteTime();
		if (this.focusdata) {
			this.getUnPicked();
			this.updateMap(this.focusdata);
		} else {
			this.updateTruckDisplay();
		}
	}


	saveDriver() {

		this.dispatchService.setDrivers(this.driverForm.value).subscribe((result: any) => {
			if (result.success) {

			} else {
				alert(result.message)
				this.loadData();
			}

			this.loadData();
			this.modalService.dismissAll();
			if (this.selectedTruck) {
				this.selectedTruck.driver = this.driverForm.get('driver').value.name;
			}

			const data = { truck: this.selectedTruck, driver: this.driverForm.value, user: this.user } //cardaction;

			if (data) {
				this.omsService.sendDriverUpdate({ data, roomName: 'driverchange' }, cb => {});
			}

			//this.driverForm = this.fb.group({
			//	driver: ['', Validators.required],
			//	truck: ['', Validators.required],
			//});
		});
	}

	cancelInlineDriver() {
		this.inlinedriver = false;
	}

	saveDriverInline() {

		this.dispatchService.setDrivers(this.driverForm.value).subscribe((result: any) => {
			this.loadData();
			if (this.selectedTruck) {
				this.selectedTruck.driver = this.driverForm.get('driver').value.name;
				const data = { truck: this.selectedTruck, driver: this.driverForm.value, user: this.user } //cardaction;

				if (data) {
					this.omsService.sendDriverUpdate({ data, roomName: 'driverchange' }, cb => {});
				}
			}
			this.inlinedriver = false;
		});
	}

	assignDriverInline(run: any) {
		this.inlinedriver = true;

		this.selectedRun = run
		this.dispatchService.getDrivers().subscribe((result: any) => {
			this.drivers = result;
			this.driverForm = this.fb.group({
				driver: ['', Validators.required],
				truck: [run],
			});
		});
	}

	assignDriver(run: any) {

		this.selectedRun = run
		this.dispatchService.getDrivers().subscribe((result: any) => {
			this.drivers = result;
			this.driverForm = this.fb.group({
				driver: ['', Validators.required],
				truck: [run],
			});
		});

		this.modalService.open(this.driverChangeRef, { ariaLabelledBy: 'modal-title', size: 'md' }).result.then((result) => {

		}, (reason) => {

		});
	}

	submitDispatch(columnid, print = true) {

		this.dispatching = false;

		let proceed = true;

		if (!this.selectedTruck.driver || this.selectedTruck.driver == '') {
			proceed = confirm('There is no driver assigned to this dispatch. Continue?');
		}

		if (this.activeDispatches[columnid].dispatched.length && proceed) {
			proceed = confirm('There is an active dispatch, this will add to the current dispatch. Continue?');
		}

		// let incomplete = this.focusdata.filter(i => !i.pick_complete);
		// if (incomplete.length && proceed) {
		// 	proceed = confirm("There are unpicked orders on this run. Continue?");
		// }

		if (proceed) {
			const data = { column: columnid, data: this.carddata[columnid], user: this.user, sendprints: print } //cardaction;

			const loadrundata = data;
			loadrundata['truck'] = this.selectedTruck;
			if (this.scantoload) {
				this.assignBay(columnid, data);
			} else {
				this.dispatching = true;
				this.omsService.sendDispatchUpdate({ data, roomName: this.CHAT_ROOM }, cb => {

					if (cb.status == 'ok') {
						this.loadData();
						if(print){
							const print_data = { column: columnid };
							this.printService.loadsheet(print_data).subscribe((r: any) => {
								setTimeout(() => {
									this.dispatching = false;
									this.focusdata = [];
									this.selectedTruck = false;
									this.toggleFlip('');
								}, 100);
							});
							
							this.printService.printRun(print_data).subscribe((r: any) => {});
						}else{
							this.dispatching = false;
							this.focusdata = [];
							this.selectedTruck = false;
							this.toggleFlip('');
						}
						
					} else {
						this.dispatching = false;
					}
				});
			}
		}
	}

	openTrackingNumberAssign(){
		this.modalService.open(this.assignTrackingRef, { ariaLabelledBy: 'modal-title', size: 'lg', backdrop: 'static' }).result.then((result) => {}, (reason) => {

		});
	}

	assignBay(columnid, data) {
		this.dispatching = true;
		const hasActiveRun = this.activeDispatches[columnid].dispatched.length
		this.omsService.sendDispatchUpdate({ data, roomName: this.CHAT_ROOM }, cb => {
			if (cb.status == 'ok') {
				this.loadData();
				
				if(this.config.env.package === 'tires'){
					const ep = this.usersService.usePrintConnect();
					this.user.usePrintConnect = ep;
				}

				const print_data = { column: columnid, user:this.user };

				//get dispnumber for bay assigning
				const truckData = {
					truck: this.selectedTruck
				};

				if (!hasActiveRun) {
				
					this.dispatchService.getDispNumber(truckData).subscribe((res) => {
						if (res.success) {
							const dispnum = res['dispnumber'];

							//get bays for assigning
							this.dispatchService.getBayStatus().subscribe((bayres: any) => {
								//sorting because sometimes the json would come back out of order
								this.bays = {
									'1-One': bayres.one,
									'2-Two': bayres.two,
									'3-Three': bayres.three
								}
								
								//if truck ups or fedex
								if(this.pickuptrucks.includes(this.selectedTruck.id)){

									const bay_data = {
										dispnumber: dispnum,
										truckid: this.selectedTruck.id,
										bay: this.selectedTruck.name == 'FEDEX' ? 4 : 5,
										priority: false
									}

									this.dispatchService.assignBay(bay_data).subscribe((res) => {
										//socket call to trigger loading of bay in warehouse-checking
										this.omsService.loadingBayAssigned({ data, roomName: this.CHAT_ROOM }, cb => {
											if (cb.status == 'ok') {
												if(data.sendprints){
													this.printService.loadsheet(print_data).subscribe((r: any) => {
														if(this.user.usePrintConnect){
															this.sendPrint(r.base64);
														}
														setTimeout(() => {
															this.dispatching = false;
															this.focusdata = [];
															this.selectedTruck = false;
															this.toggleFlip('');
															// this.openTrackingNumberAssign()
														}, 100);
													});
												}else{
													this.dispatching = false;
													this.focusdata = [];
													this.selectedTruck = false;
													this.toggleFlip('');
												}

											}
										});
									})
								//open popup for selection, not a pickup truck
								}else{ 
									this.modalService.open(this.assignBayRef, { ariaLabelledBy: 'modal-title', size: 'lg', backdrop: 'static', keyboard: false }).result.then((result) => {}, (reason) => {
										if (dispnum != '') {
											//on close assign bay and print run
											const bay_data = {
												dispnumber: dispnum,
												truckid: this.selectedTruck.id,
												bay: this.baySelection,
												priority: this.bayGroup.get('priority').value
											}
	
											this.dispatchService.assignBay(bay_data).subscribe((res) => {
												//socket call to trigger loading of bay in warehouse-checking
												this.omsService.loadingBayAssigned({ data, roomName: this.CHAT_ROOM }, cb => {
													if (cb.status == 'ok') {
														if(data.sendprints){
															this.printService.loadsheet(print_data).subscribe((r: any) => {
																if(this.user.usePrintConnect){
																	this.sendPrint(r.base64);
																}
																setTimeout(() => {
																	this.dispatching = false;
																	this.focusdata = [];
																	this.selectedTruck = false;
																	this.toggleFlip('');
																}, 100);
															});
														}else{
															this.dispatching = false;
															this.focusdata = [];
															this.selectedTruck = false;
															this.toggleFlip('');
														}
													
													}
												});
											})
										}
									});
								}	

							})
						}
					})

				} else {
					
					this.omsService.loadingBayAssigned({ data, roomName: this.CHAT_ROOM }, cb => {
						if (cb.status == 'ok') {
							if(data.sendprints){
								this.printService.loadsheet(print_data).subscribe((r: any) => {
									setTimeout(() => {
										this.dispatching = false;
										this.focusdata = [];
										this.selectedTruck = false;
										this.toggleFlip('');
									}, 100);
								});
							}else{
								this.dispatching = false;
								this.focusdata = [];
								this.selectedTruck = false;
								this.toggleFlip('')
							}

						}
					});
				}

				if(data.sendprints){
					
					this.printService.printRun(print_data).subscribe((r: any) => {
						if(this.user.usePrintConnect){
							this.sendPrint(r.base64);
						}
					});
				}

			} else {
				this.dispatching = false;
			}
		});
	}

	sendPrint(data: []){
		const type = 'DISPATCH';
		const user = this.user.user.userid;
		const printers = this.usersService.getDevicesByType(user, type);
		if (printers && printers.length && data.length) {
			this.omsService.setNewOrder();
			data.forEach(doc => {
				const data = { pdf: doc, user: user, devices: printers }	
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			});
		}
	}

	CloseAssignBay(selection) {
		this.baySelection = selection;
		this.modalService.dismissAll();
	}

	removeBaySort(key) {
		return key.split('-')[1];
	}

	scanToAddOrder(event: any) {
		event.preventDefault();
		if (this.selectedColumn.length) {
			const items = this.globalSearchService.filterItem(this.allavailableorders, event.target.value, 'order');
			if (items.length == 1) {
				const indeof = this.allavailableorders.indexOf(items[0])
				this.moveItem(this.allavailableorders[indeof])
				this.scantoadd2.setValue('');
				this.scantoadd1.setValue('');
			} else {
				if (items.length > 1) {
					alert('Multiple Found - for ' + this.scantoadd1.value);
				} else {
					const refresh = confirm('Order Not Found, Refresh?' + this.scantoadd1.value);
					if (refresh) {
						window.location.reload();
					}
				}
			}

		} else {
			this.scantoadd2.setValue('');
			this.scantoadd1.setValue('');
			alert('Select a Truck');
		}

	}

	onInput(event: any, keys = 'orderno') {
		if (event.target.value != '') {
			this.filteredItems = this.globalSearchService.filterItem(this.allavailableorders, event.target.value, 'customer.address,order,terms');
		} else {
			this.filterPicked();
		}
	}

	/**
	 * Filter route and orders together
	 */
	filterOrders() {
		this.filteredItems = this.pickable;

		//this.filterByRoute()
		this.filterPicked()
	}

	alreadyInList(item: any, list: any) {
		return list.indexOf(item) >= 0 ? true : false;
	}

	filterPicked() {
		//these can have crossovers. not ok for multiple
		let results = [];
		const filters = this.pickstatus.value;
		if (this.allavailableorders) {
			filters.forEach(filter => {
				switch (filter) {
				case 'inbound': {
					break;
				}
				case 'credit': {
					const filtered_results = this.allavailableorders.filter((card: any) => {
						return card.ordertype == '11' && !this.alreadyInList(card, results);
					})
					results = [...results, ...filtered_results];
					break;
				}
				case 'picked_only': {
					const filtered_results = this.allavailableorders.filter((card: any) => {
						return !(card.info.daystilldue > 0) && card.pick_complete === true && !this.alreadyInList(card, results)
					})
					results = [...results, ...filtered_results];

					break;
				}
				case 'partial_pick': {
					const filtered_results = this.allavailableorders.filter((card: any) => {
						return card.partial_pick === true && !card.notfillable && !this.alreadyInList(card, results)
					});
					results = [...results, ...filtered_results];
					break;
				}

				case 'not_due_only': {
					const filtered_results = this.allavailableorders.filter((card: any) => {
						return card.info.daystilldue > 0 && card.pick_complete === false && !this.alreadyInList(card, results)
					});
					results = [...results, ...filtered_results];
					break;
				}
				case 'not_due_and_picked': {
					const filtered_results = this.filteredItems.filter((card: any) => {
						return card.info.daystilldue > 0 && card.pick_complete === true && !this.alreadyInList(card, results)
					});
					results = [...results, ...filtered_results];
					break;
				}
				case 'is_fillable': {

					const filtered_results = this.allavailableorders.filter((card: any) => {
						return (card.info.daystilldue <= 0 && !card.notfillable && !this.alreadyInList(card, results));
					});
					results = [...results, ...filtered_results];
					break;
				}

				case 'is_not_fillable': {
					const filtered_results = this.allavailableorders.filter((card: any) => {
						return (card.notfillable && !this.alreadyInList(card, results));
					});
					results = [...results, ...filtered_results];
					break;
				}
				case '': {
					const filtered_results = this.allavailableorders;
					results = filtered_results;
					break;
				}
				default: {
					const filtered_results = this.allavailableorders;
					results = filtered_results;
					break;
				}
				}
				this.filteredItems = results;

				if (this.selected_route.value != '') {
					this.filteredItems = this.globalSearchService.filterItem(this.filteredItems, this.selected_route.value, 'route');
				}

			})
		} else {
			return false;
		}

	}

	filterByRoute() {

		if (this.selected_route.value != '') {
			this.filteredItems = this.globalSearchService.filterItem(this.pickable, this.selected_route.value, 'route');
		} else {
			this.filteredItems = this.pickable
		}
	}

	updateTruckDisplay() {

		if (this.allsortcolumns && this.selectedColumn != '') {
			this.sortcolumns = this.allsortcolumns.filter(i => {
				//was multiple moving to single
				//return this.selectedColumn.includes(i.id)
				return this.selectedColumn == i.id
			})
			if (this.scantoaddRef.nativeElement) {
				setTimeout(() => this.scantoaddRef.nativeElement.focus(), 0);
			}
		} else {
			this.sortcolumns = (this.allsortcolumns) ? this.allsortcolumns : [];
			this.selectedColumn = '';
		}
	}

	updateTimes(column: any) {
		this.dispatchService.updateTimes(column).subscribe(async (r: any) => {

		})
	}

	getRouteTotalTime() {
		try {
			if (this.focusdata) {
				const runTime = this.focusdata[this.focusdata.length - 1].info.runtime
				this.setSeperateRouteTime()
				//this.checkDriverOverTimeLimit(runTime)
			}
		} catch (e: unknown) {
			this.loadData() //Reload the data if there is an issue
		}
	}

	/**
	 * Get the time of the individual route from one marker to another
	 */
	setSeperateRouteTime(): void {
		try {
			const convertSecondsToUnixTime = (routeTime: number): string => {
				const timeAdd = (Number.isNaN(routeTime)) ? 0 : routeTime;
				return moment.unix((timeAdd) ? timeAdd : 0).utc().format((timeAdd >= 3600) ? 'H [Hours,] m [Minutes]' : 'm [Minutes]')
			}
			let totalRouteTime = 0
			if (this.focusdata && this.focusdata.length) {
				for (let i = 0; i < this.focusdata.length; ++i) {
					const lastCard = this.focusdata[i - 1]
					const card = this.focusdata[i]

					const routeTime = ((lastCard && lastCard.address === card.address)) // If the location is the same as the previous
						?
						0 //If the delivery is the same location
						:
						+card.info.esttime + this.deliveryStopTime // stop time + route time

					if (Number.isNaN(routeTime)) {

					}

					const rtime = convertSecondsToUnixTime(routeTime);

					totalRouteTime += routeTime
					//dsptime does not always have the correct time when the two addresses are the same. We must manually check it.
					card['info']['rtime'] = rtime
					card['info']['dsptime'] = convertSecondsToUnixTime(totalRouteTime);
				}

				this.focusruntime = convertSecondsToUnixTime(totalRouteTime);
				this.setDeliveryReturnTimes(totalRouteTime);
			}
		}
		//Focusdata could be boolean or an array. This will catch if this runs whilst focusdata is boolean.
		catch (e: unknown) {

		}
	}

	/**
	 * Check if the driver will be late after the last delivery
	 * @param deliveryTime The total time from all deliveries
	 */
	checkDriverOverTimeLimit(deliveryTime: number): void {
		if (!deliveryTime) {
			return
		}

		const currentTime = new Date(this.loadDataTime)

		currentTime.setSeconds(currentTime.getSeconds() + deliveryTime)
		this.driverOverTimeLimit = (currentTime.getHours() >= 15) ? 'Delivery will go past 3pm' : ''
	}


	/**
	 * Set the estimated return times of the driver
	 * @param deliveryTime The total time from all deliveries
	 */
	setDeliveryReturnTimes(deliveryTime: number): void {
		if (!deliveryTime) {
			return
		}

		const currentTime = new Date(this.loadDataTime)

		currentTime.setSeconds(currentTime.getSeconds() + deliveryTime)
		this.deliveryReturnTime = currentTime.toLocaleTimeString()
	}

	moveItem(item: any) {
		if (this.selectedColumn) {

			const thisitem = item;
			let proceed = true;
			//move back to order list no check on dates etc.

			const isdue = this.itemIsDue(thisitem);
			if (!isdue) {
				const conf = confirm('Item Not Due Yet. Procced?')
				proceed = false;
				if (conf) {
					proceed = true;
				}
			}

			//	if (!thisitem.pick_complete && item.type != '11') {
			//		let conf = confirm('Items Not Picked Yet. Procced?')
			//		proceed = false;
			//		if (conf) {
			//			proceed = true;
			//		}
			//	}

			if (proceed) {
				const indexfrom = this.filteredItems.indexOf(item);
				const indexto = this.carddata[this.selectedColumn].push(item);
				this.filteredItems.splice(indexfrom, 1);
				this.pushPullItem(item);
				// this.sortcolumns = this.filteredItems;
				const cardaction = {
					pindex: indexfrom,
					cindex: indexto,
					list: this.carddata[this.selectedColumn],
					message: this.carddata
				}

				this.submitMessage(cardaction);
				this.getRouteTotalTime()
			}
		}
	}

	// updateDeviceDisplay(event: any, columnid: any) {
	// 	let data = {
	// 		device: event.value,
	// 		column: columnid,
	// 	}
	// 	this.devicesselected[columnid] = event.value
	// 	this.carddata[columnid].device = event.value;
	// 	this.dispatchService.updateDevice(data).subscribe((r:any) => {

	// 	})

	// }
	updateDeviceDisplay(scannervalue: any = '', columnid: any) {
		const data = {
			device: scannervalue,
			column: columnid,
		}
		this.devicesselected[columnid] = scannervalue;
		this.carddata[columnid].device = scannervalue;
		this.dispatchService.updateDevice(data).subscribe((r: any) => {

		})
	}

	dropSingle(event: CdkDragDrop < string[] > , list: any) {
		this.hovered_item = '';
		const thisitem = event.previousContainer.data[event.previousIndex];
		let proceed = true;

		if (event.container.data != this.filteredItems) {
			const isdue = this.itemIsDue(thisitem);
			if (!isdue) {
				const conf = confirm('Item Not Due Yet. Procced?')
				proceed = false;
				if (conf) {
					proceed = true;
				}
			}
		}

		if (proceed) {


			if (event.previousContainer === event.container) {
				moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
			} else {

				transferArrayItem(event.previousContainer.data,
					event.container.data,
					event.previousIndex,
					event.currentIndex);
				this.pushPullItem(thisitem);
			}

			const cardaction = {
				pindex: event.previousIndex,
				cindex: event.currentIndex,
				list: list,
				message: this.carddata
			}

			this.submitMessage(cardaction);

			const thislist = list;
			let i = 0;
			thislist.forEach(item => {
				item.sort = i
				i++;
			})
			//setTimeout(() => {
			//this.updateMap(thislist);
			//this.updateTimes('');
			//this.updateMap(this.focusdata);

			//}, 500);
		}

	}

	getAddress(place: any) {
		this.place = place

		const componenets = place['address_components'];
		const name = place['name'];
		const phone = place['formatted_phone_number'];
		const website = place['website'];

		const address1 = this.parseComponentShortName(componenets, ['street_number', 'route']);
		let address2 = this.parseComponentShortName(componenets, ['subpremise']);
		const address3 = this.parseComponentShortName(componenets, ['locality']);
		const address4 = this.parseComponentShortName(componenets, ['administrative_area_level_1']);
		const address5 = this.parseComponentShortName(componenets, ['postal_code']);
		const address6 = this.parseComponentLongName(componenets, ['country']);

		if (name) {

		}

		if (phone) {}

		if (address2 != '' && address2) {
			address2 = '<br>' + address2;
		}

		const address = address1 + address2 + '<br>' + address3 + ' ' + address4 + ', ' + address5;

		this.customDestination.get('type').setValue('4')
		this.customDestination.get('label').setValue(name)
		this.customDestination.get('address').setValue(address)
		this.customDestination.get('lat').setValue(this.place.geometry.location.lat())
		this.customDestination.get('lng').setValue(this.place.geometry.location.lng())

	}

	itemIsDue(item: any) {
		if (parseInt(item.info.daystilldue) > 0) {
			return false;
		}
		return true;
	}

	addPoint(column: any) {

		this.customDestination.get('column').setValue(column);
		this.modalService.open(this.addDestinationRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

		}, (reason) => {

		});
	}

	addCustomDestination() {
		this.dispatchService.addPoint(this.customDestination.value).subscribe(r => {
			this.customDestination = this.fb.group({
				label: ['', Validators.required],
				address: ['', Validators.required],
				lat: ['', ],
				lng: ['', ],
				type: [''],
				column: [''],
			});
			this.modalService.dismissAll();
			this.loadData();

		})
	}

	private parseComponentShortName(componenets: any, types: any) {

		const result = [];
		componenets.forEach((comp: any) => {
			const compa = comp.types.map((local: any) => {
				if (types.includes(local)) {
					const adda = (comp.short_name) ? comp.short_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}

	private parseComponentLongName(componenets: any, types: any) {
		const result = [];
		componenets.forEach((comp: any) => {
			const compa = comp.types.map((local: any) => {
				if (types.includes(local)) {
					const adda = (comp.long_name) ? comp.long_name : '';
					result.push(adda);
				}
			});
		})
		return result.join(' ');
	}



	drop(event: CdkDragDrop < any > , list: string) {

		const thisitem = event.previousContainer.data[event.previousIndex];

		let proceed = true;
		let reloadpre = false;
		//move back to order list no need to check dates / capacity etc.
		if (event.container.data != this.filteredItems) {
			const isdue = this.itemIsDue(thisitem);
			if (!isdue) {
				const conf = confirm('Item Not Due Yet. Procced?')
				proceed = false;
				if (conf) {
					proceed = true;
				}
			}

			const columnddata = this.sortcolumns.filter(r => { return r.id == list })[0];
			const nextvolume = this.getCapacityLoaded(list) + thisitem.totalvolume;

			if (nextvolume > columnddata.capacity) {

				const conf = confirm('Over Capacity. Procced?')
				proceed = false;
				if (conf) {
					proceed = true;
				}

			}
		} else {
			//removed from list update prepayment
			reloadpre = true;
		}

		this.pushPullItem(thisitem);

		if (proceed) {
			if (event.previousContainer === event.container) {
				moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
			} else {
				transferArrayItem(event.previousContainer.data,
					event.container.data,
					event.previousIndex,
					event.currentIndex);
			}




			const cardaction = {
				pindex: event.previousIndex,
				cindex: event.currentIndex,
				list: list,
				message: this.carddata
			}
			this.submitMessage(cardaction);


			if (reloadpre && this.selectedTruck.id) {
				this.getPrePay(this.selectedTruck.id)
				this.getUnPicked();

			}
		}

	}

	pushPullItem(item: any) {
		const currentindex = this.allavailableorders.indexOf(item);
		if (currentindex < 0) {
			this.allavailableorders.push(item);
		} else {
			this.allavailableorders.splice(currentindex, 1);
		}
	}

	toggleLock(truck: any) {
		truck.unlocked = (truck.unlocked) ? false : true;
	}


	forceCommitDispatch(columnfocus: any) {

		this.selectedTruck = this.allsortcolumns.filter(i => { return i.id == columnfocus })[0]
		this.columnfocus = columnfocus;
		this.focusdata = this.carddata[columnfocus];

		let proceed = true;

		if (!this.selectedTruck.driver || this.selectedTruck.driver == '') {
			proceed = confirm('There is no driver assigned to this dispatchContinue?');
		}

		if (this.activeDispatches[columnfocus].dispatched) {
			if (this.activeDispatches[columnfocus].dispatched.length && proceed) {
				proceed = confirm('There is an active dispatch, this will add to the current dispatch. Continue?');
			}
		}

		if (proceed) {
			const data = { column: columnfocus, data: this.carddata[columnfocus], user: this.user }
			this.omsService.sendDispatchUpdate({ data, roomName: this.CHAT_ROOM }, cb => {
				const print_data = { column: columnfocus };
				this.printService.loadsheet(print_data).subscribe((r: any) => {
					// 					this.testcontent = r.content;
					// 					this.modalService.open(this.testingContentRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
					//
					// 					}, (reason) => {
					//
					// 					});
				});

				this.printService.printRun(print_data).subscribe((r: any) => {});
			});
		}
	}

	submitMessage(cardaction) {
		const data = {
			carddata: this.carddata,
			selected_dispatch: this.selectedTruck,
			devices: this.devicesselected,
		}
		//const data = this.carddata //cardaction;
		if (data) {
			this.omsService.sendCardUpdate({ data, roomName: this.CHAT_ROOM }, cb => {
				if (this.columnfocus) {
					//cb sinlge preview has updated data
					if (cb.status == 'ok') {
						if (cb.singlepreview) {

							cb.singlepreview.data.forEach((order: any) => {
								const fitem = this.focusdata.filter((a: any) => {
									return a.orderno == order.orderno
								})[0]
								const index = this.focusdata.indexOf(fitem);

								if (index >= 0) {
									this.focusdata[index].info = order.info;

								}
							})
							if (this.selectedTruck.id) {
								//this.updateTimes(this.selectedTruck.id)
							}
							if (this.focusdata) {
								this.getUnPicked();
								this.getRouteTotalTime();
								this.updateMap(this.focusdata);
							}
						}
					}
				}
			});
		}
	}

	onHeaderClick(event) {
		if (!this.expandEnabled) {
			event.stopPropagation();
		}
	}

	onDotClick(event) {
		if (!this.expandEnabled) {
			event.stopPropagation();
		}
	}

	onExpandEntry(expanded, index) {

	}

	toggleSide() {
		this.side = this.side === 'left' ? 'right' : 'left';
	}

	getColumnFocus() {
		if (this.columnfocus) {
			this.focusdata = this.carddata[this.columnfocus];
			this.getRouteTotalTime();
			return this.carddata[this.columnfocus];
		} else {
			this.focusdata = false;
			return false;
		}
	}

	setColumnFocus(column) {
		this.columnfocus = column;
	}

	removeFromOms(order: any, index: any) {

		if (index >= 0) {
			this.focusdata.splice(index, 1)
		}

		const data = { orderno: order }
		this.dispatchService.removeOrderFromOms(data).subscribe(r => {
			this.loadData();
		})
	}

	deleteRun(column: any) {
		const data = { truckid: column }
		let updateBays = false;
		if (this.config.scantotruck) {
			updateBays = true;
			this.dispatchService.truckHasLoads(data).subscribe((res) => {
				if (res.hasLoads) {
					alert('This truck still has tires loaded. Unload tires before deleting run.')
					return;
				} else {
					const ok = confirm('Delete Entire Run?');
					if (ok) {
						const data2 = { truckid: column, details: res.loading_details }
						this.dispatchService.deleteRun(data2).subscribe(r => {
							this.modalService.dismissAll();
							this.loadData();
							const data = { truck: column, user: this.user }
							if (data) {
								this.omsService.sendDispatchPositionUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
								if (updateBays) {
									this.omsService.loadingBayAssigned({ data, roomName: this.CHAT_ROOM }, cb => {});
								}
							}
						});
					}
				}
			});
		} else {
			const ok = confirm('Delete Entire Run?');
			if (ok) {
				this.dispatchService.deleteRun(data).subscribe(r => {
					this.modalService.dismissAll();
					this.loadData();
					const data = { truck: column, user: this.user }
					if (data) {
						this.omsService.sendDispatchPositionUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
						if (updateBays) {
							this.omsService.loadingBayAssigned({ data, roomName: this.CHAT_ROOM }, cb => {});
						}
					}
				});
			}
		}
	}

	transferOmsTo() {
		const data = {
			from: this.fromTruckOms.value,
			to: this.toTruckOms.value,
		}
		this.dispatchService.moveOms(data).subscribe(r => {
			this.loadData();
			this.modalService.dismissAll();
			this.fromTruckOms.setValue('');
			this.toTruckOms.setValue('');
		})
	}

	changeTruck(column: any) {

		this.fromTruckOms.setValue(column);
		this.modalService.open(this.changeTruckEleRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	clearOmsColumn(column) {
		this.dispatchService.clearOmsColumn(column).subscribe(r => {
			this.loadData();
		});
	}

	clearRun(column) {

		this.dispatchService.clearRun(column).subscribe(r => {
			this.loadData();
		});
	}

	clearRunSaveForLater(column) {

		this.dispatchService.clearRunSaveForLater(column).subscribe(r => {
			this.loadData();
		});
	}

	getDropType() {
		if (this.innerWidth > 600) {
			return 'horizontal';
		} else {
			return 'vertical';
		}
	}

	zoomToPoint(point: any) {

		const lat = (!Number.isNaN(point.lat)) ? parseFloat(point.lat) : 0;
		const lng = (!Number.isNaN(point.lng)) ? parseFloat(point.lng) : 0;
		if (google) {
			const ltlng = new google.maps.LatLng(lat, lng);
			if (this.updated_map) {
				this.updated_map.setZoom(12);
				this.updated_map.setCenter(ltlng);
			} else {
				this.map.setZoom(12);
				this.map.setCenter(ltlng);
			}
		}
	}

	getRecalc(column) {
		this.hovered_item = false;
		this.dispatchService.getRecalc(column).subscribe((results: any) => {
			this.carddata[column] = results;
		});
	}

	getRecalcSingle(column) {
		if (this.selectedTruck.unlocked) {
			this.hovered_item = false;
			this.dispatchService.getRecalc(column).subscribe((results: any) => {
				this.carddata[column] = results;
				this.focusdata = results;
				this.getRouteTotalTime();
				this.updateMap(this.focusdata);
			});
		}
	}

	getActiveRun(column: any) {
		this.viewactiverun = column
		this.editactivedispatch = true;
		// 		this.modalService.open(this.viewActiveRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
		//
		// 		}, (reason) => {
		//
		// 		});

	}

	runList(column: any, activerun: any) {
		this.active_run = activerun;
		this.run_list = this.carddata[column];
		this.dispatchService.getRunPick(column).subscribe((results: any) => {
			this.runlist = results.items;
			this.totalonrun = results.items.reduce(function(accumulator, item) {
				return accumulator + parseFloat(item.ordered);
			}, 0);
		});
	}

	back(): void {
		this.location.back()
	}

	updateMap(data: any) {

		if (this.markers) {
			this.markers.forEach(r => {
				if (r) {
					r.setMap(null)
				}
			})
		}

		this.markers = [];

		const infoWindow = new google.maps.InfoWindow();
		infoWindow.close();
		this.removeLines();

		let shortlines = [];
		//todo make this part of company settings
		const home = { lat: 42.928455044944165, lng: -78.82142723259965 }

		const columndata = Array.from(data); //Require this to be an array

		shortlines = [home];

		//start
		//shortlines.push(home);

		const i = 0;
		if (columndata) {
			columndata.forEach((item: any) => {
				const ltlng = new google.maps.LatLng(item.lat, item.lng);
				const itemsort = item.sort + 1;
				const m = new google.maps.Marker({
					position: ltlng,
					title: '(' + itemsort + ') ' + item.orderno,
					optimized: true,
					animation: null,
					label: {
						text: '(' + itemsort + ')',
						color: '#fff',
						fontSize: '14px',
						fontWeight: 'bold'
					}
				});

				m.addListener('click', () => {
					if (this.hovered_item == item.orderno) {
						infoWindow.close();
						this.hovered_item = false;
					} else {
						infoWindow.close();
						infoWindow.setContent(item.address);
						infoWindow.open(m.getMap(), m);
						this.hovered_item = item.orderno;
					}
					//this.zoomToPoint(item)
				});


				this.markers.push(m);

				shortlines.push({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) })
			});
		}
		shortlines.push(home)

		const myLatlng = new google.maps.LatLng(42.928455044944165, -78.82142723259965);
		const mapOptions = {
			zoom: 11,
			center: myLatlng,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};

		if (!this.updated_map) {
			this.updated_map = new google.maps.Map(document.getElementById('map'), mapOptions);
		}

		//this.map = new google.maps.Map(document.getElementById("map"), mapOptions);

		const marker = new google.maps.Marker({
			position: myLatlng,
			title: 'Home'
		});

		marker.setMap(this.updated_map);

		this.markers.forEach((item: any) => {
			item.setMap(this.updated_map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		this.pathlines = new google.maps.Polyline({
			path: shortlines,
			geodesic: true,
			strokeColor: '#F1575A',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			icons: [{
				icon: lineSymbol,
				offset: '100%'
			}],
		});

		this.pathlines.setMap(this.updated_map);
	}

	stepSelectionChange(event: any) {

		this.currentStep = event.selectedIndex;

		//if (!thisitem.pick_complete  && thisitem.type != '11') {
		//	let conf = confirm('Items Not Picked Yet. Procced?')
		//	proceed = false;
		//	if (conf) {
		//		proceed = true;
		//	}
		//}

		switch (event.selectedIndex) {
		//payments
		case 0:
			this.ordershidden = true;
			break;
		case 1:
			this.ordershidden = true;
			//this.getPrePay(this.selectedTruck)
			break;
		case 2:
			this.ordershidden = true;
			break;
		default:
			this.ordershidden = true;
			break;
		}
	}

	countPrePayments(): number {
		let prepays = 0;
		if (this.focusdata && this.focusdata.length) {
			prepays = this.focusdata.reduce(function(accumulator, item) {
				let addon = 0;
				if (item.info.processcc) {
					addon = 1;
				}
				return accumulator + addon;
			}, 0);
		}
		return prepays;
	}

	drawMap(column) {

		this.currentStep = 0;
		this.globalSearchService.hideSideBar();

		if (this.updated_map) {
			this.updated_map = false;
		}

		this.selectedTruck = this.allsortcolumns.filter(i => { return i.id == column })[0]
		this.selectedTruck.unlocked = true;

		const coordinates = [];
		this.columnfocus = column;

		this.setColumnFocus(column);
		this.focusdata = this.carddata[column];

		this.getRouteTotalTime();

		const infoWindow = new google.maps.InfoWindow();

		//this.getPrePay(column);
		//todo make this part of company settings
		const home = { lat: 42.928455044944165, lng: -78.82142723259965 }
		const lines = [home];
		const columndata = this.carddata[column];

		if (columndata) {
			const counter = 0;
			columndata.forEach((item: any) => {
				lines.push({ lat: parseFloat(item.lat), lng: parseFloat(item.lng) })
				const ltlng = new google.maps.LatLng(item.lat, item.lng);
				//counter +1;
				let itemsort = 1 + item.sort


				const m = new google.maps.Marker({
					position: ltlng,
					title: '(' + itemsort + ') ' + item.orderno,
					optimized: true,
					animation: google.maps.Animation.DROP,
					label: {
						text: '(' + itemsort + ')',
						color: '#fff',
						fontSize: '14px',
						fontWeight: 'bold'
					}
				});


				m.addListener('click', () => {
					infoWindow.close();
					infoWindow.setContent(item.address);
					infoWindow.open(m.getMap(), m);
					this.hovered_item = item.orderno;
					//this.zoomToPoint(item)
				});

				coordinates.push(m);
				itemsort++;
			});
		}

		lines.push(home);

		const myLatlng = new google.maps.LatLng(42.928455044944165, -78.82142723259965);
		const mapOptions = {
			zoom: 11,
			center: myLatlng,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};


		this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

		const marker = new google.maps.Marker({
			position: myLatlng,
			title: 'Home'
		});

		marker.setMap(this.map);

		coordinates.forEach((item: any) => {
			item.setMap(this.map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		const pathTo = new google.maps.Polyline({
			path: lines,
			geodesic: true,
			strokeColor: '#F1575A',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			icons: [{
				icon: lineSymbol,
				offset: '100%'
			}],
		});

		pathTo.setMap(this.map);

	}

	identify(index, item) {
		return item.did;
	}

	clearInput() {
		this.sortcolumns = this.allsortcolumns
		this.selectedColumn = '';
	}

	toggleFlip(column: any) {

		if (column == '') {
			this.focusdata = [];
			this.columnfocus = false;

		} else {
			this.setColumnFocus(column);
			this.selectedColumn = column;
			this.focusdata = this.carddata[column];

			this.selectedTruck = this.allsortcolumns.filter(i => { return i.id == column })[0]
			this.selectedTruck.unlocked = true;

		}

		let proceed = true;

		if (this.flip == 'inactive') {
			if (this.activeDispatches[column].dispatched.length) {
				proceed = confirm('There is an active dispatch, continue?');
			}
		}

		if (proceed) {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
			if (this.flip == 'inactive') {
				this.selectedColumn = '';
			} else {
				if (column != '') {


					this.updateTimes(column);
					this.updateMap(this.focusdata);
					this.getPrePay(column);
				}
			}
		}

		this.filterPicked();
	}

	getCapacityLoaded(column_id: any) {
		let totalvolume = 0;
		if (this.carddata[column_id].length) {
			totalvolume = this.carddata[column_id].reduce(function(accumulator, i) {
				return accumulator + i.totalvolume;
			}, 0);

		}
		return totalvolume;
	}

	toggleAddingCard(p: any) {
		p.addingcardparent = (p.addingcardparent) ? false : true;
	}

	updateProfile(event: any, p: any) {

		const order = this.needpayments.filter(i => {
			return i.details.header.orderno == event.orderno
		})[0]

		if (order) {
			const index = this.needpayments.indexOf(order);

			this.needpayments[index].cc_on_file = true;
			this.needpayments[index].cardsonfile = event.card.cards
			this.needpayments[index].details.payments[0].payment_method = event.card.cards[0].paymentid;
			this.needpayments[index].addingcardparent = false;
			this.needpayments[index].cc_charge = event.card.cards[0];
		}

		p.addingcardparent = false;

	}

	removeAllChanges(orderNo: string) {
		const data = {
			orderno: orderNo
		}
		this.dispatchService.closeOrderChange(data).subscribe(r => {
			this.order_changes = this.order_changes.filter(order => order.orderno !== orderNo);
			this.loadOrderChanges();
		});
	}


	removeChange(change) {
		this.order_changes = this.order_changes.map(order => {
			order.header = order.header.filter(headerChange => headerChange !== change);
			order.lines = order.lines.filter(lineChange => lineChange !== change);
			return order;
		});
	}


	compareObjects(originalObject: any, newObject: any): any {
		let changesString = '';

		// Loop through keys of the original object
		Object.keys(originalObject).forEach(key => {
			// Check if the value of the key has changed in the new object
			if (originalObject[key] !== newObject[key]) {
				// If changed, concatenate the key and its new value to the changes string
				changesString += `${key}: ${originalObject[key]} -> ${newObject[key]}\n`;
			}
		});

		// If there are no changes, return a message indicating so
		if (changesString === '') {
			return false;
		} else {
			return changesString;
		}
	}

	openModal(): void {
		this.order_changes = this.order_changes.map(order => ({ ...order, expanded: false }));
		this.modalService.open(this.changesEleRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});

	}
}